import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=54b24cc3&"
import script from "./ManageOrganization.vue?vue&type=script&lang=js&"
export * from "./ManageOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrganization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports